import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Fab from "@mui/material/Fab";
import Chip from "@mui/material/Chip";
import { Link } from "react-router-dom";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import { useDispatch } from "react-redux";
import { addCommas } from "@persian-tools/persian-tools";
const ReceiptTableRow = (props) => {
	const dispatch = useDispatch();

	const clickHandler = () => {
		dispatch({
			type: "assign",
			payload: {
				prevRoute: "/lab/receipts/view",
				index: 0,
			},
		});
	};
	return (
		<React.Fragment>
			<TableRow hover>
				<TableCell align="justify">
					<Link
						to={`/lab/receipts/view/${props.receiptId}`}
						style={{ color: "inherit", textDecoration: "inherit" }}
					>
						<Fab
							color="secondary"
							size="small"
							onClick={clickHandler}
						>
							<DatasetLinkedIcon />
						</Fab>
					</Link>
				</TableCell>
				<TableCell align="justify">{props.receiptCode}</TableCell>
				<TableCell align="justify">{props.submissionDate}</TableCell>
				<TableCell align="justify">{props.doctorName}</TableCell>
				<TableCell align="justify">{props.name}</TableCell>
				<TableCell align="justify">{props.orderCount}</TableCell>
				<TableCell align="justify">
					{addCommas(props.totalPrice)}
				</TableCell>
				<TableCell align="justify">
					<Chip
						label={props.isPaid ? "پرداخت شده" : "پرداخت نشده"}
						color={props.isPaid ? "success" : "error"}
					/>
				</TableCell>
			</TableRow>
			<TableRow></TableRow>
		</React.Fragment>
	);
};
export default ReceiptTableRow;
